import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import GambleRequestPayload from "slotworks/model/gameplay/requests/gamble-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function GambleCollectCommand(): Contract<void> {
    const record: SpinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
    if (record.gamble) {
        record.gamble = false;

        const payload = new GambleRequestPayload();
        payload.id = (GameState.getCurrentGame().getCurrentRecord() as SpinRecord).gambleID;

        return CommsManager.request(payload);
    } else {
        return Contract.empty();
    }
}
